import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';
import { AttributeDefinitionFormData } from '@src/app/shared/components/attribute-definition-form/attribute-definition.model';
import { RetailerAttributeDefinitionsAdapter } from '../retailer-attribute-definitions.adapter';

@Component({
  selector: 'app-add-retailer-attribute-definitions',
  templateUrl: './add-retailer-attribute-definitions.component.html',
  styleUrl: './add-retailer-attribute-definitions.component.scss',
  host: {
    class: 'app-add-retailer-attribute-definitions'
  },
  standalone: false
})
export class AddRetailerAttributeDefinitionsComponent extends BaseViewComponent {
  constructor(
    private router: Router,
    private retailerAttributeDefinitionsAdapter: RetailerAttributeDefinitionsAdapter
  ) {
    super();
  }

  async submitForm(definition: AttributeDefinitionFormData): Promise<void> {
    await this.retailerAttributeDefinitionsAdapter.create(definition);
    this.router.navigate(['/retailer-attribute-definitions']);
  }
}
